import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatMoeda, handleNumberOnly } from "../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faQrcode } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import auxService from "../../services/AuxService";
import { MakeMessageError } from "../../components/Components";
import { useNavigate } from 'react-router-dom';

interface formProps {
    nome: string;
    cpfcnpj: string;
    recorrencia: string;
    valor: string;
    assinatura_id: number;
}

const initialState: formProps = {
    nome: '',
    cpfcnpj: '',
    recorrencia: '3',
    valor: '600,00',
    assinatura_id: 1
}

interface TenantInterface {
    id: number | string;
    assinatura: {};
    data_vencimento: string;
    empresas: [];
    limite_empresas: number;
    name: string;
    total: number;
}

const initialTenantState: TenantInterface = {
    id: '',
    assinatura: {},
    data_vencimento: '',
    empresas: [],
    limite_empresas: 0,
    name: '',
    total: 0
}

const initialFieldsError = {
    cpfcnpj: [],
    nome: [],
    assinatura_id: [],
}

export default function FormAssinatura() {
    const [form, setForm] = useState(initialState);
    const [tenant, setTenant] = useState<TenantInterface>(initialTenantState);
    const navigate = useNavigate();
    const [errors, setErrors] = useState(initialFieldsError);
    const btnGerarQrCode = useRef<HTMLButtonElement | null>(null);
    const btnVoltar = useRef<HTMLAnchorElement | null>(null);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: "" }));
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        desabilitaButtonFooter();
        auxService.postCreateAssinatura(form)
            .then(res => {
                desabilitaButtonFooter(false);
                console.log('res:', res);
                navigate('/qrcode', {
                    state: {
                        qrcode: res.data.qrcode,
                        image: res.data.image,
                        documento: res.data.documento,
                        valor: res.data.valor,
                        tipo: 'assinatura'
                    }
                });
            })
            .catch(error => {
                desabilitaButtonFooter(false);

                if (error.response) {
                    if (error.response.status === 422) {
                        setErrors(error.response.data);
                    }
                }
            })
    };

    const desabilitaButtonFooter = (status = true) => {

        if (status) {

            if (btnGerarQrCode.current) {
                btnGerarQrCode.current.disabled = true;
            }

            if (btnVoltar.current) {
                btnVoltar.current.style.pointerEvents = 'none';
                btnVoltar.current.style.opacity = '0.5';
                btnVoltar.current.style.cursor = 'not-allowed';
            }
        } else {

            if (btnGerarQrCode.current) {
                btnGerarQrCode.current.disabled = false;
            }

            if (btnVoltar.current) {
                btnVoltar.current.style.pointerEvents = 'auto';
                btnVoltar.current.style.opacity = '1';
                btnVoltar.current.style.cursor = 'pointer';
            }
        }
    }
    useEffect(() => {
        auxService.getTenant().then(res => {
            setTenant(res);
        });
    }, [])

    return (<div className="d-flex justify-content-center align-items-center vh-100">
        <div className="row col-md-6 mx-auto">
            <Form onSubmit={handleSubmit}>

                <Card className="card-primary card-outline">
                    <Card.Header>
                        <h5 className="text-center text-uppercase">Dados do assinante</h5>
                    </Card.Header>
                    <Card.Body>
                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-3" controlId="nome">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control type="text" maxLength={60} autoFocus value={form.nome}
                                        onChange={handleChange} name="nome" />
                                    <MakeMessageError errors={errors} field="nome" />
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group className="mb-3" controlId="cpfcnpj">
                                    <Form.Label>CPF/CNPJ</Form.Label>
                                    <Form.Control type="text" maxLength={14} onKeyUp={handleNumberOnly}
                                        value={form.cpfcnpj} onChange={handleChange} name="cpfcnpj" />
                                    <MakeMessageError errors={errors} field="cpfcnpj" />
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-3" controlId="recorrencia">
                                    <Form.Label>Recorrencia</Form.Label>
                                    <Form.Select required value={form.recorrencia} name="recorrencia"
                                    >
                                        <option value="3">Anual</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md>
                                <Form.Group className="mb-3" controlId="valor">
                                    <Form.Label>Valor</Form.Label>
                                    <Form.Control type="text" disabled
                                        value={formatMoeda(tenant.total)} name="valor" />
                                </Form.Group>
                            </Col>
                        </Row>

                    </Card.Body>
                    <Card.Footer>
                        <div className="row justify-content-end" >
                            <div className="col-md">
                                <Link to="/assinatura" className="btn btn-secondary me-2" ref={btnVoltar}>
                                    <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                                </Link>
                            </div>

                            <div className="col-md-auto">
                                <Button variant="primary" type="submit" ref={btnGerarQrCode} >
                                    <FontAwesomeIcon icon={faQrcode} /> Gerar Pagamento
                                </Button>
                            </div>
                        </div>

                    </Card.Footer>
                </Card>
            </Form>
        </div>
    </div>)
}